de:
  at: um
  on: am
fr:
  at: à
  on: le
it:
  at: alle
  on: il
